import React from 'react'
import { NavLink } from 'react-router-dom';
import Slider from 'react-slick/lib/slider';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function HomeSavedSearchesSlider() {
    // slider arrows is set custom style
    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        draggable: false,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 3,
                }
            }
        ]
    };
    return (
        <div className='w-full  relative font-dropdownFont savedSearchesSlider'>
            <Slider {...settings}>
                {
                    // categoriesMainDataHomeTeam &&
                    // categoriesMainDataHomeTeam.map((item, i) => (
                    <NavLink to="/" >
                        <div className="border  border-white rounded-[0.313rem] mx-[0.625rem]    text-white text-xs py-[5px] px-[10px] min-h-[5rem] flex -tracking-tighter   items-center">
                            <div>
                                <div className='line-three max-h-12 my-auto font-semibold mb-1'>
                                    No saved searches
                                </div>
                                <div className='text-[rgba(255,255,255,0.45)] line-two'>
                                    Your favourite answears will appear here after saving them during searching process.
                                </div>
                            </div>
                        </div>
                    </NavLink>
                    // ))
                }
            </Slider>
        </div >
    )
}
